App.controller('LogoutCtrl', LogoutCtrl);

LogoutCtrl.$inject = [
    '$location',
    'localStorageService',
    'DispatcherService',
    'DialogService'
];

function LogoutCtrl($location, localStorageService, DispatcherService, DialogService) {
    this.submit = submit;

    function submit() {
        DispatcherService.post('logout').then(function() {
            localStorageService.remove('token');

            DialogService.success('You have been successfully logged out');

            $location.path('/login');
        });
    }
}